import { Button } from '@vfit/shared/atoms';
import { useMediaQuery } from '@vfit/shared/hooks';
import { purify } from '@vfit/shared/themes';
import { Children, useEffect, useState } from 'react';
import Tags from '../Tags/tags';
import { DefaultMax, Increment, ISearch } from './searchGrid.models';
import {
  Divider,
  DividerGrid,
  ButtonContainer,
  ItemContainer,
  GridContainer,
  SearchContainer,
  TitleH3,
} from './searchGrid.style';

const SearchGrid = ({
  title,
  tags,
  toggleTags,
  elements,
  onClickElement,
  onIncrementSearch,
}: ISearch) => {
  // HTML - CMS purifier
  const [pTitle] = purify([title || '']);
  /**
   * - Setting the max #items to be as mobile DoD
   * - Setting the maxIncrement to be as mobile DoD
   */
  const [max, setMax] = useState<DefaultMax>(DefaultMax.MOBILE);
  const [maxIncrement, setMaxIncrement] = useState<Increment>(Increment.MOBILE);

  const isDesktop = useMediaQuery('bigDesktop', 'min');
  const isTablet = useMediaQuery('tablet', 'min');

  useEffect(() => {
    if (isDesktop) {
      // Desktop MAX
      setMax(DefaultMax.DESKTOP);
      setMaxIncrement(Increment.DESKTOP);
    } else if (isTablet) {
      // Tablet MAX
      setMax(DefaultMax.TABLET);
      setMaxIncrement(Increment.TABLET);
    } else {
      setMax(DefaultMax.MOBILE);
      setMaxIncrement(Increment.MOBILE);
    }
  }, [isTablet, isDesktop]);

  const onHandleClick = (increment: number) => {
    setMax((prev) => prev + increment);
  };

  return (
    <SearchContainer>
      {pTitle && (
        <TitleH3
          dangerouslySetInnerHTML={{
            __html: pTitle,
          }}
        />
      )}
      <Divider />
      {tags && tags?.length > 1 && (
        <Tags type="outlined" variant="white" tags={tags} toggleTags={toggleTags} />
      )}
      <DividerGrid />
      <GridContainer>
        {Children.toArray(
          elements?.map((el, indexElement) =>
            indexElement < max ? (
              <ItemContainer
                onClick={() => {
                  onClickElement?.(indexElement);
                }}
              >
                {el}
              </ItemContainer>
            ) : null
          )
        )}
      </GridContainer>
      <DividerGrid />
      {elements?.length > max && (
        <ButtonContainer>
          <Button
            onClick={() => {
              onHandleClick(maxIncrement);
              onIncrementSearch?.();
            }}
          >
            CARICA PIÙ RISULTATI
          </Button>
        </ButtonContainer>
      )}
    </SearchContainer>
  );
};

export default SearchGrid;
